<div class="data-loaderr">
  <div class="loader-circle">
    <div class="loader-line-mask">
      <div class="loader-line"></div>
    </div>
    <div class="content"> <img src="assets/images/yourstore_logo_only.svg" alt="logo"> </div>
  </div>
</div>